import { useCampaignContext } from '../../../context';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { SectionWrapper, SectionHeader, LightText } from '../Sections.styled';

export const IN_APP_OPTIONS_SECTION_TEST_ID = 'in-app-options-section';

const inAppPrioritiesMapper: Record<number, string> = {
  400.5: 'Low',
  300.5: 'Medium',
  200.5: 'High',
  100.5: 'Critical',
};
export const InAppOptionsSection = () => {
  const {
    campaign: { priorityLevel, mobileAppIds },
  } = useCampaignContext();

  return (
    <SectionWrapper data-test={IN_APP_OPTIONS_SECTION_TEST_ID}>
      <SectionHeader>IN-APP OPTIONS</SectionHeader>
      <CampaignFormField labelText="Send to specific apps">
        <ReadOnlyField name="mobileAppIds">
          {mobileAppIds?.length > 0 ? 'On' : <LightText>Off</LightText>}
        </ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Display priority">
        <ReadOnlyField name="priorityLevel">
          {inAppPrioritiesMapper?.[priorityLevel] || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
    </SectionWrapper>
  );
};
